'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserLog } from '../../Entities/User/UserLog';
import { UserLogCollection } from '../../Collections/User/UserLogCollection';

export class UserLogRepository extends CoreRepository {
  public getUserLogs(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserLogs(userId, options).then((response) => {
      const collection = new UserLogCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserLog();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createUserLog(userId: number, payload: any[]) {
    return this.webAPI.createUserLog(userId, payload).then((response) => {
      const indPhone = new UserLog();
      indPhone.hydrate(response);

      return indPhone;
    });
  }

  public removeUserLog(userId: number, userLogId: number) {
    return this.webAPI.removeUserLog(userId, userLogId).then((response) => {
      return response;
    });
  }

  public updateUserLog(userId: number, userLogId: number, payload: any[]) {
    return this.webAPI.updateUserLog(userId, userLogId, payload).then((response) => {
      return response;
    });
  }

  /*
    public getUserLog(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getUserLog(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let UserLog = new UserLog();
            UserLog.hydrate(response);

            return UserLog;
        });
    }

    public createUserLog(payload: object = {}){  
    return this.webAPI.createUserLog(payload)
      .then( response => {
        let UserLog = new UserLog();
        UserLog.hydrate(response);

        return UserLog;
      });
    }

    public updateUserLog(payload: object = {}){  
        return this.webAPI.updateUserLog(payload)
        .then( response => {
            let UserLog = new UserLog();
            UserLog.hydrate(response);

            return UserLog;
        });
    }

    public removeUserLog( ){
        return this.webAPI.removeUserLog()
        .then( response => {
            return response;
        });
    }
    */
}
